export default function ResearchSection() {
  return (
    <section id="research" className="py-24 md:py-32 bg-[#f8faff]">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="mb-12">
          <span className="text-xs font-medium tracking-widest uppercase text-[#3b82f6] font-['Inter']">Publications</span>
          <h2 className="font-['DM_Serif_Display'] text-4xl md:text-5xl text-[#0f172a] mt-3">Policy &amp; Research Insights</h2>
          <p className="text-[#475569] text-sm max-w-md mt-3 leading-relaxed font-['Inter']">
            Cash Learn integrates economic research, workforce transition data, and institutional policy analysis to inform scalable education reform design. Stay tuned for upcoming research.
          </p>
        </div>
      </div>
    </section>
  );
}
